import { Formatters, Messages } from '../../codegen/Localize';

export function characterCounter(args: {value: string, maximum: number}): string {
  const remaining = args.maximum - args.value.length;
  const overflow = args.value.length > args.maximum;

  if (overflow) {
    return Messages.characterLimitExceeded({
      COUNT_LOC: Formatters.formatCount(args.value.length),
      LIMIT_LOC: Formatters.formatCount(args.maximum)
    });
  }

  return Messages.remainingCharacters({
    COUNT: remaining,
    COUNT_LOC: Formatters.formatCount(remaining)
  });
}
